import { createAction, props } from '@ngrx/store';
import { INavigatorDashboardDataPeriods } from '../../interfaces/INavigatorDashboardData';

export const loadNavigatorDashboardData = createAction(
  '[NavigatorDashboardData] Load',
  props<{ projectUuid: string }>()
);

export const loadNavigatorDashboardDataSuccess = createAction(
  '[NavigatorDashboardData] Load Success',
  props<{ periods: INavigatorDashboardDataPeriods }>()
);

export const loadNavigatorDashboardDataFailure = createAction(
  '[NavigatorDashboardData] Load Failure',
  props<{ error: any }>()
);
